type ExtendedWindow = Window &
  typeof globalThis & {
    webkitRequestAnimationFrame: (callback: FrameRequestCallback) => number;
    mozRequestAnimationFrame: (callback: FrameRequestCallback) => number;
  };

export const silencer =
  (fn: (() => void) | null, ...params: any) =>
  (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (fn && typeof fn === 'function') {
      fn.apply(null, params);
    }
  };

const getFrame = (() => {
  if (process.env.SSR) {
    return (callback: () => void) => setTimeout(callback, 1000 / 60);
  }

  return (
    window.requestAnimationFrame ||
    (window as ExtendedWindow).webkitRequestAnimationFrame ||
    (window as ExtendedWindow).mozRequestAnimationFrame ||
    ((callback) => setTimeout(callback, 1000 / 60))
  );
})();

const scrollTopAnimated = (target = 0, speed = 250) => {
  if (process.env.SSR) {
    return;
  }

  const current = window.scrollY || document.documentElement.scrollTop;
  let currentTime = 0;
  const time = Math.max(0.1, Math.min(Math.abs(current - target) / speed, 0.8));
  const easing = (position: number) => -0.5 * (Math.cos(Math.PI * position) - 1);
  const tick = () => {
    currentTime += 1 / 60;

    const p = currentTime / time;
    const t = easing(p);

    if (p < 1) {
      getFrame(tick);
      window.scrollTo(0, current + (target - current) * t);
    } else {
      window.scrollTo(0, target);
    }
  };

  tick();
};

export const resetViewport = (smooth = false) => {
  if (smooth) {
    scrollTopAnimated(0, 5000);
  } else {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
};
